import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/kesehatan',
    name: 'kesehatan', 
    component: () => import('../views/page/kesehatan.vue')
  },
  {
    path: '/brida',
    name: 'brida', 
    component: () => import('../views/page/brida.vue')
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
